import React from 'react'
import { useLocation } from 'react-router-dom';

const CraftSelectTooltip = () => {

  const {pathname} = useLocation();

  const getText = () => {
    if (pathname.includes('identity')) {
      return 'Place card in crafting slot to view Identity matches. Click "Select" button in left side panel or double click on card to slot it.'
    } else if (pathname.includes('prediction')) {
      return 'Click on a card and press "Select" button in left side panel or double click on card to slot it.'
    }
  }

  return (
    <div className='craft-block__title-tooltip'>
      <p className='craft-block__title-tooltip-text'>{getText()}</p>
    </div>
  )
}

export default CraftSelectTooltip;
